module.exports = __webpack_public_path__ + "img/payment-method.6d08121e.svg";